import React from 'react';
import P from 'prop-types';

const SignOut = ({ fill, className, size }) => {
  return (
    <svg
      className={className}
      style={{
        width: size,
        height: size,
      }}
      viewBox="0 0 98 98"
    >
      <g fill={fill}>
        <path d="M37.9 86.6c17.1 0 25-9.9 27.6-13.2 1.6-2 1.3-5-.8-6.5-.8-.7-1.8-1-2.9-1-1.4 0-2.8.6-3.7 1.8-3.6 4.5-9.1 9.7-20.2 9.7-15.5 0-28.1-12.6-28.1-28.1 0-15.5 12.6-28.1 28.1-28.1 11.2 0 16.7 5.2 20.2 9.7 1.6 2 4.5 2.4 6.6.8 2-1.6 2.4-4.5.8-6.6-2.6-3.3-10.5-13.2-27.6-13.2C17.3 11.9.5 28.7.5 49.3c0 20.6 16.8 37.3 37.4 37.3z"/>
        <path d="M81.8 44.6H35.5c-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7h46.2l-6.6 6.6c-.9.9-1.4 2.1-1.4 3.3 0 1.2.5 2.4 1.4 3.3 1.8 1.8 4.8 1.8 6.6 0l14.5-14.7c1.8-1.8 1.8-4.8 0-6.6L81.7 31.2c-.9-.9-2.1-1.4-3.3-1.4-1.2 0-2.4.5-3.3 1.3-.9.9-1.4 2-1.4 3.3 0 1.2.5 2.4 1.3 3.3l6.8 6.9z"/>
      </g>
    </svg>
  );
};

SignOut.propTypes = {
  fill: P.string.isRequired,
  className: P.string,
  size: P.number,
};

export default SignOut;
